// extracted by mini-css-extract-plugin
module.exports = {"root":"GroupsCollapse_root__1gwhY","openTitle":"GroupsCollapse_openTitle__3Opo0","space":"GroupsCollapse_space__14r-3","actions":"GroupsCollapse_actions__iZpg-"};